import {
  faMicrophoneSlash,
  faVideoSlash,
} from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "@growtherapy/sprout-ui";
import { RenderTemplate } from "../../../components/RenderTemplate";
import { getSessionInteractionInfo } from "../../../config";
import { toast } from "../../../toasts";

const INITIAL_AUDIO_VIDEO_DISABLED_TOAST_KEY = "initial-audio-video-disabled";

const slots = {
  "mic-off-icon": <Icon icon={faMicrophoneSlash} />,
  "cam-off-icon": <Icon icon={faVideoSlash} />,
};

export function showSessionInteractionPrompt() {
  const message = getSessionInteractionInfo()["TREE-349.message"];

  toast.info(<RenderTemplate template={message} slots={slots} />, {
    timeout: Infinity,
    key: INITIAL_AUDIO_VIDEO_DISABLED_TOAST_KEY,
  });
}

export function closeSessionInteractionPrompt() {
  toast.close(INITIAL_AUDIO_VIDEO_DISABLED_TOAST_KEY);
}
